import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const Hero = () => {
    const scrollToAbout = () => {
        const element = document.querySelector('#about');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section
            id="home"
            className="min-h-screen flex items-center justify-center relative px-4 sm:px-6 lg:px-8 bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: 'url(/images/hero-bg.jpg)',
            }}
        >
            <div className="absolute inset-0 bg-gradient-to-br from-black/50 to-black/30"></div>

            <div className="max-w-7xl mx-auto text-center w-full relative z-10">
                <div className="max-w-4xl mx-auto">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-lg">
                        Yazılım Çözümlerinde
                        <span className="text-primary-400 block mt-2">Güvenilir Ortağınız</span>
                    </h1>
                    <p className="text-lg sm:text-xl md:text-2xl text-gray-100 mb-6 sm:mb-8 leading-relaxed max-w-3xl mx-auto drop-shadow-md">
                        Modern teknolojilerle işletmenizi dijital dönüşümde destekliyoruz.
                        Web uygulamalarından mobil çözümlere kadar her alanda yanınızdayız.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center max-w-md sm:max-w-none mx-auto">
                        <button
                            onClick={() => document.querySelector('#projects')?.scrollIntoView({ behavior: 'smooth' })}
                            className="bg-primary-500 text-white px-6 sm:px-8 py-3 rounded-lg text-base sm:text-lg font-semibold hover:bg-primary-600 transition-colors duration-200 w-full sm:w-auto"
                        >
                            Projelerimizi İncele
                        </button>
                        <button
                            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
                         className="bg-primary-500 text-white px-6 sm:px-8 py-3 rounded-lg text-base sm:text-lg font-semibold hover:bg-primary-600 transition-colors duration-200 w-full sm:w-auto"
                        >
                            İletişime Geç
                        </button>
                    </div>
                </div>
            </div>

            <button
                onClick={scrollToAbout}
                className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce z-10 drop-shadow-lg"
            >
                <ChevronDownIcon className="h-8 w-8" />
            </button>
        </section>
    );
};

export default Hero;
